<template>
    <div id="payment_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
            
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="vehicleManufacturerHeader">Make Payment</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackToPage('back')" >
                           <i class="hi-icon icon-flback"> </i> Back
                        </button>
                    </div>
                    <div class="admin-page-content ">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <form autocomplete="off" class="form-horizontal basic-form-container">
                                    <div class="form-group">
                                        <div class="col-xs-12">
                                            <label class="control-label required">Customer:</label>
                                                <v-select v-model="customer" name="checkUser" class="col-xs-12 col-sm-6"
                                                          label="text" :filterable="false" :options="customerArr"
                                                          @search="onSearch"
                                                          placeholder="Select Customer" @input="selectCustomer">
                                                    <template slot="no-options">
                                                        Search Customers...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            <div class="d-error">{{customer_error}}</div>
                                        </div>

                                        <div class="clearfix"></div>

                                        <div class="col-xs-12">
                                            <label class="control-label">Invoices:</label>
                                                <v-select v-model="invoices" name="checkInvoices" class="col-xs-12 col-sm-6"
                                                          label="text" multiple :options="invoiceArr"
                                                          placeholder="Select Invoice" >
                                                </v-select>
                                            <div class="c-error"></div>
                                        </div>

                                        <div class="col-xs-12">
                                            <div class="" v-if="outstanding != ''">
                                                <label class="control-label required">Outstanding Amount:</label>
                                                    <label>$ &nbsp;{{outstanding}}</label>
                                            </div>
                                            <div class="">
                                                <label class="control-label required">Amount To Pay:</label>
                                                    <input type="text" class="form-control" placeholder="Enter Amount" v-model="amounttopay">
                                                    <div class="d-error">{{pay_error}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="col-xs-12 btm-action-btn-fl">
                                        <div class="row">
                                            <button type="submit" id="payBtn" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="makePayment()" >
                                                <i class="hi-icon icon-flpay"> </i> Pay
                                            </button>

                                            <button type="submit" id="cancelBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click="BackToPage('cancel')" >
                                                <i class="hi-icon icon-flCancel"> </i> Cancel
                                            </button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
    import EventBus from "./../event-bus";
    import Vue from "vue";
    
    import {commonMixins} from '../../mixins/commonMixins';
    
    
    
    export default {
        name: "PaymentCreate",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Create Payment | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins],
        data: () => ({
            permissions: [],
            name: "",
            code: "",
            loading:false,
            invoiceArr:[],
            invoices:[],
            amounttopay:"",
            outstanding:"",
            customer:null,
            inv_error:"",
            customerArr : [],
            customer_error:"",
            pay_error:"",
            cantAccessPage:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'make_payment') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            },
            //get customer invoices
            customer: function(cust){
                var self = this;
                if(typeof(cust) != 'undefined' && cust != null){
                    self.getInvoices(cust.value);
                } else {
                    self.outstanding = '';
                    self.amounttopay = '';
                }
            },

            //change amount to pay on select invoice
            invoices: function (inv) {

                var oldInv = inv;
                var tempArr = {};

                if ( inv.length == 0 ) {
                    return;
                }

                //check duplicate
                for( var i=0; i<oldInv.length; i++ ) {
                    var checkval = oldInv[i].value;

                    if ( tempArr[checkval] === undefined ) {
                        tempArr[checkval] = 1;
                    } else {
                        tempArr[checkval] = tempArr[checkval] + 1;
                    }
                }

                this.amounttopay = 0;
                for( var i=0;i<inv.length;i++) {

                    //check duplicate in temp array
                    if ( tempArr[inv[i].value] > 1 ) {
                        this.invoices.splice(i,1);
                    } else {
                        this.amounttopay += inv[i].amount;
                    }

                }
                this.amounttopay = this.amounttopay.toFixed(2)
            },

            //unselect invoices if invoice amount total and amount to pay is not equal
            amounttopay: function (amount) {

                var invoiceAmount = 0;
                for( var i=0;i<this.invoices.length;i++) {
                    invoiceAmount += this.invoices[i].amount;
                }
                if ( amount != invoiceAmount ) {
                    this.invoices = [];
                }
                console.log(this.invoices);
            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();

            var custId = self.$route.query.custId;
           
            if(custId && custId != ''){
                self.getCustomer(custId);
            }
        },
        methods: {

            onSearch(search, loading)
            {
                if (search.length > 1) {
                    loading(true);
                    this.checkCustomer(loading, search, this);
                }
            },

            numberFormat(amount) {
                return parseFloat(amount).toFixed(2);
            },
            BackToPage(flag) {

                var self = this;

                self.customerArr = [];
                self.customer = '';
                self.outstanding = '';
                self.amounttopay = '';

                var checkPage = self.$route.query.bookingId;

                if ( checkPage ) {
                    self.$router.push("/booking/view/"+checkPage);
                } else {
                    self.$router.push("/payment/list");
                }
            },

            getInvoices: function(id){
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/search/invoices",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data:{
                        customer_id:id
                    },

                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        //self.CheckBtn = 'Check';
                        if (data.status == "success") {
                            self.loading = false;
                            self.invoiceArr = data.content;
                        }
                    },

                    error: function (jqXHR, exception) {
                        self.loading = false;
                        //self.CheckBtn = 'Check';
                        self.generateStatusCodeMessage(jqXHR,true,'search-invoices');
                    }
                });

            },
            getCustomer: function(id){
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/getCustomer",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        
                        customer_id:id
                    },
                    dataType: "json",
                    success: function (data) {

                        //self.CheckBtn = 'Check';
                        if (data.status == "success") {
                            self.loading = false;
                            self.customer = data.content;
                        }
                    },

                    error: function (jqXHR, exception) {
                        self.loading = false;
                        //self.CheckBtn = 'Check';
                        self.generateStatusCodeMessage(jqXHR,true,'search-customers');
                    }
                });
            },
            //when select customer in make payment mddal
            selectCustomer(event) {
                var self = this;
                if ( event != null) {
                    
                    if(event != '') {

                        self.outstanding = self.numberFormat(event.outstanding);
                        self.amounttopay = self.numberFormat(event.outstanding);
                    }
                    
                } else {
                    self.outstanding = "";
                    self.amounttopay = "";
                }
            },
            checkCustomer: function (loading, search) {

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/search",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        search: search,
                        flag:"customer",
                    },
                    dataType: "json",
                    success: function (data) {

                        //self.CheckBtn = 'Check';
                        if (data.status == "success") {
                            self.loading = false;
                            loading(false);
                            self.customerArr = data.content;


                        } else if (data.status == "error") {
                            self.loading = false;
                            self.error_msg = data.message;
                            self.msgClass = "error";
                            self.msg = false;

                        }
                    },

                    error: function (jqXHR, exception) {
                        self.loading = false;
                        //self.CheckBtn = 'Check';
                        self.generateStatusCodeMessage(jqXHR,true,'check-customers');
                    }
                });

            },
            makePayment: function(){

                var self = this;
                self.pay_error = '';
                self.customer_error = '';
                if( self.customer.value == "" || self.customer.value == null || !self.customer.value){
                    self.customer_error = 'Customer Field Required';
                }
                // if(self.customer == ''){
                //     self.customer_error = 'Customer Field Required';
                // }

                if(!self.amounttopay){
                    self.pay_error = 'Amount Required';
                }
                if(self.amounttopay && self.amounttopay < 1 ){
                    self.pay_error = 'Amount can not be less than 1.';
                }
                if(self.amounttopay && !self.amounttopay.match(/^[0-9 , '.']*$/)){
                    self.pay_error = "Amount to Pay must be Numeric";
                }

                if(self.pay_error != '' || self.customer_error != ''){
                    return;
                }


                //get invoice number as string
                var invString = "";
                if ( self.invoices.length > 0 ) {
                    for( var i=0;i<self.invoices.length;i++ ){

                        if ( invString == "" ) {
                            invString = self.invoices[i].value;
                        } else {
                            invString +=","+self.invoices[i].value;
                        }
                    }
                }

                //invoices:self.invoices,
                $("#payBtn").text("Processing...", true);
                $("#payBtn").prop("disabled", true);
                $("#cancelBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.RENTAL_API + process.env.VERSION +"/process_payment",
                    crossDomain: true,
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        paymentMethod:'credit_card',
                        amount:self.amounttopay,
                        customer_id:self.customer.value,
                        flag:'paymentlist'
                    },
                    success: function (data) {

                        self.loading = false;
                        $("#payBtn").text("Pay");
                        $("#payBtn").prop("disabled", false);
                        $("#cancelBtn").prop("disabled", false);


                        if (data.status == "success") {
                            var uId = data.content.uId.split( '=' );

                            var rentalUrl = process.env.RENTAL_URL+'payment?';
                            rentalUrl += "secret="+localStorage.getItem("tkn");
                            rentalUrl += "&uId="+uId[1];
                            rentalUrl += "&sessionId="+data.content.sessionId;
                            rentalUrl += "&bookingRef="+data.content.bookingRef;
                            rentalUrl += "&redirectFlag="+data.content.flag;
                            rentalUrl += "&invoices="+invString;


                            self.customerArr = [];
                            self.customer = null;
                            self.outstanding = '';
                            self.amounttopay = '';

                            window.open(rentalUrl,'_blank');


                        }
                    },
                    error: function (jqXHR, exception) {

                        self.loading = false;
                        $("#payBtn").text("Pay");
                        $("#payBtn").prop("disabled", false);
                        $("#cancelBtn").prop("disabled", false);

                        self.generateStatusCodeMessage(jqXHR,true,'payment-process');
                    }
                });

            },

        }
    };
</script>


// WEBPACK FOOTER //
// src/components/payment/PaymentCreate.vue